import {
  AbstractControl,
  FormArray,
  ValidationErrors,
  ValidatorFn,
} from '@angular/forms';

export const checkDifferencesValidator = (fixedKeys: string[]): ValidatorFn => {
  return (control: AbstractControl): ValidationErrors | null => {
    if (!fixedKeys) return null;
    const keysArray = control as FormArray;
    const formKeys = keysArray.controls.map(
      ctrl => ctrl.get('properties.key')?.value
    );
    const missingKeys = fixedKeys.filter(key => !formKeys.includes(key));
    return missingKeys.length > 0 ? { differences: missingKeys } : null;
  };
};
